<template>
    <div class="bg-white">
        <div class="overflow-hidden">
            <div class="relative left-1/2 -ml-240 w-[1920px] mx-auto">
                <picture class="object-cover mx-auto">
                    <source  srcset="~@/assets/img/topic/2023/antarctica/img-1.webp" alt="A21海空联航" />
                    <img  src="~@/assets/img/topic/2023/antarctica/img-1.png" alt="A21海空联航" />
                </picture>
                <picture class="object-cover mx-auto">
                    <source  srcset="~@/assets/img/topic/2023/antarctica/img-2.webp" alt="A21海空联航" />
                    <img  src="~@/assets/img/topic/2023/antarctica/img-2.png" alt="A21海空联航" />
                </picture>
                <picture class="object-cover mx-auto">
                    <source  srcset="~@/assets/img/topic/2023/antarctica/img-3.webp" alt="A21海空联航" />
                    <img  src="~@/assets/img/topic/2023/antarctica/img-3.png" alt="A21海空联航" />
                </picture>
                <picture class="object-cover mx-auto">
                    <source  srcset="~@/assets/img/topic/2023/antarctica/img-4.webp" alt="A21海空联航" />
                    <img  src="~@/assets/img/topic/2023/antarctica/img-4.png" alt="A21海空联航" />
                </picture>
                <picture class="object-cover mx-auto">
                    <source  srcset="~@/assets/img/topic/2023/antarctica/img-5.webp" alt="A21海空联航" />
                    <img  src="~@/assets/img/topic/2023/antarctica/img-5.png" alt="A21海空联航" />
                </picture>
            </div>
        </div>
        <div :class="$style.footer">
            <el-button size="large" type="primary" class="w-[180px]" @click="$router.push({
                path: '/product/automation/foreign-cruise-search?cruise_route_first=&brand=47&year=&country=&day=&route=&cruise=296&city=&month=&q=&tag=&cruise_type=&sort_name=5&sort_type=4&date_start=&date_end='
            })">立即预订</el-button>
        </div>
    </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
    auth: false,
    // layout: 'Main',
    head: {
        title: '神往南极15日'
    }
})
</script>

<style lang="scss" module>
.footer {
  margin-top: 1.25rem;
  padding: 0.75rem;
  position: -webkit-sticky;
  position: sticky;
  bottom: 0px;
  text-align: center;
  background: #fff linear-gradient(360deg, #DFE6F1 0%, rgba(244,244,244,0) 100%);
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
}
</style>